class GWPDropdown extends HTMLElement {
    constructor() {
      super();
  
      this.dropdownBtn = this.querySelector(".dropdown-btn");
      this.dropdownOptions = this.querySelectorAll(".dropdown-options .option");
    }
  
    reset() {
      this.dropdownBtn = this.querySelector(".dropdown-btn");
      this.dropdownOptions = this.querySelectorAll(".dropdown-options .option");
  
      this.connectedCallback();
    }
  
    connectedCallback() {
      this.dropdownBtn.addEventListener("click", this.toggleDropdown.bind(this));
      this.dropdownOptions.forEach((option) => {
        option.addEventListener("click", this.chooseValue.bind(this, option));
      });
  
      document.querySelector("body").addEventListener("click", (event) => {
        const eventPath = event.path || event.composedPath();
        if(!eventPath.includes(this.dropdownBtn)) {
          this.dropdownBtn.classList.remove("open");
        }
      });
  
      // set interaction for atc button (if data-atc-interactor label is on)
      if(this.hasAttribute("data-atc-interactor")) {
        this.atcBtn = this.closest(".gwp__container").querySelector("button");
        this.atcBtn.dataset.value = this.dropdownBtn.dataset.value;
        this.atcBtn.dataset.type = this.dropdownBtn.dataset.type;
        this.atcBtn.dataset.handle = this.dropdownBtn.dataset.handle;
        this.atcBtn.dataset.color = this.dropdownBtn.dataset.color;
        this.atcBtn.dataset.title = this.dropdownBtn.dataset.title;
        this.atcBtn.dataset.size = this.dropdownBtn.dataset.size;
        this.atcBtn.dataset.compare = this.dropdownBtn.dataset.compare;
        this.atcBtn.dataset.id = this.dropdownBtn.dataset.id;
      }
  
      // image wrapper
      this.imageWrapper = this.closest('.gwp__container').querySelector(".gwp-img__container");
      this.priceWrapper = this.closest('.gwp__container').querySelector(".gwp-item_price");
    }
  
    ICONCARET() {
      return `
        <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-caret" viewBox="0 0 10 6">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor">
        </svg>
      `;
    }
  
    toggleDropdown() {
      this.dropdownBtn.classList.toggle("open");
    }
  
    chooseValue(option) {
      const optionTitle = option.innerHTML;
      const optionValue = option.dataset.value;
  
      this.dropdownBtn.querySelector("span").innerHTML = `${optionTitle}`;
      this.dropdownBtn.dataset.value = optionValue;
  
      if(this.atcBtn) {
        this.atcBtn.dataset.value = optionValue;
        this.atcBtn.dataset.size = option.dataset.size;
      }
  
      this.dropdownBtn.classList.remove("open");
    }
  }
  
  customElements.define("gwp-dropdown", GWPDropdown);
  
  
  class GWPFormSwitcher extends GWPDropdown {
    constructor() {
      super();
  
      this.sizeDropdown = this.closest(".gwp__container").querySelector("gwp-dropdown[data-type='size']");
    }
  
    // @Override
    chooseValue(option) {
      const optionTitle = option.innerHTML;
      const optionValue = option.dataset.value;
  
      this.dropdownBtn.querySelector("span.color-value").innerHTML = `${optionTitle}`;
      this.dropdownBtn.querySelector("span.color-picker").setAttribute("class", `color-picker ${ optionTitle.trim().replace(" ", "-").toLowerCase() } hidden`);
      this.dropdownBtn.dataset.value = optionValue;
  
      this.changeSizeDropdown(option.dataset.product, optionValue);
  
      this.dropdownBtn.classList.remove("open");
    }
  
    changeSizeDropdown(productObject, color) {
      console.log("first", productObject)
      const gwpVariantData = window.gwpData;
      const selectedProd = gwpVariantData[productObject];
      const availableVariantsFromSelectedProd = selectedProd.variants.filter(variant => variant.available && variant.option1 == color);
      
      const sizeHTML = `
        <div class="dropdown-btn" data-handle="${selectedProd.packdummy_handle}" data-id="${selectedProd.id}" data-compare="${selectedProd.compare_at_price}" data-size="${availableVariantsFromSelectedProd[0].option2}" data-title="${selectedProd.title}" data-color="${color}" data-type="${selectedProd.title.toLowerCase().includes('pack') ? 'pack' : 'single'}" data-value="${availableVariantsFromSelectedProd[0].id}">
          <span>${availableVariantsFromSelectedProd[0].option2}</span>
          ${this.ICONCARET()}
        </div>
        <div class="dropdown-options">
          ${selectedProd.variants.filter(variant => variant.option1 == color).map((variant) => `
            <span class="option" data-compare="${selectedProd.compare_at_price}" data-size="${variant.option2}" data-title="${selectedProd.title}" data-color="${variant.color}" data-type="${variant.title.toLowerCase().includes('pack') ? 'pack' : 'single'}" data-value="${variant.id}" ${!variant.available ? "disabled" : ""}>
              ${variant.option2}
            </span>
          `).join("")}
        </div>
      `;
  
      if(this.imageWrapper) {
        const imgHTML = `<img src="${availableVariantsFromSelectedProd[0].featured_image.src}" loading="lazy">`;
        this.imageWrapper.innerHTML = imgHTML;
      }
      if(this.priceWrapper) {
        if(gwpVariantData.widget_type == 'gwp') {
          this.priceWrapper.innerHTML = `
            <span class="gwp-item_price free">FREE</span>
          `;
        } else { 
          this.priceWrapper.innerHTML = `
          ${window.theme.cart_currency_symbol} ${Shopify.formatMoneyAmmount(availableVariantsFromSelectedProd[0].price / 100)}
          `;
        }
      }
  
      this.sizeDropdown.innerHTML = sizeHTML;
  
      this.sizeDropdown.reset();
    }
  }
  
  customElements.define("gwp-form-switcher", GWPFormSwitcher)